import authentication from './authentication'
import customer from './customer'

export default {
  authentication,
  customer,
}
